import { store } from '@/decorators/store';
import { TripNote } from '@/entities/TripNote';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';
import { ITripNote } from '~/api/ITripNote';

@store({ id: 'TripNoteStore' })
export class TripNoteStore extends AbstractEntityStore<TripNote> {
  protected entityIdKey = 'noteId';
  protected entityLabelKey = 'name';
  protected entityValueKey = 'name';

  public tmpTripNotes: ITripNote[] = [];

  updateTmpNote(...notes: ITripNote[]) {
    notes.forEach((entity: ITripNote) => {
      const index = this.tmpTripNotes.findIndex((e) => e.noteId === entity.noteId);

      if (index === -1) {
        this.tmpTripNotes.push(entity);
      }
      else {
        this.tmpTripNotes.splice(index, 1, entity);
      }
    });
  }

  deleteTmpNote(noteId: number) {
    const index = this.tmpTripNotes.findIndex((e) => e.noteId === noteId);
    if (index !== -1) {
      this.tmpTripNotes.splice(index, 1);
    }
  }
}
